import {
  VISIT_TYPE_PRESENTIAL,
  visitLocationOptions,
  visitTypeOptions,
} from '../constants/visitConstants';
import Select from 'react-select';
import { OfficeAddress } from '../models/visitsInvestorModel';
import { VisitInfo } from '../models/guestInvestorModel';
import { useNavigate } from 'react-router-dom';
import { VisitPreSaleState } from '../../../constants/visitsConstants';
import AdminListGroup, {
  DisplayItem,
} from '../../../components/admin/AdminListGroup';

import InvestorVisitsBadge from '../../../components/badges/InvestorVisitsBadge';

interface Props {
  guestVisit: VisitInfo;
  visitType?: string | null;
  onChangeVisitType?: (visitType: string) => void;
  location?: string | null;
  onChangeLocation?: (location: string) => void;
  projectAddress?: string;
  officeAddress?: OfficeAddress | null;
}

const InvestorVisitDetailCard = ({
  guestVisit,
  visitType,
  onChangeVisitType,
  location,
  onChangeLocation,
  projectAddress,
  officeAddress,
}: Props) => {
  const navigate = useNavigate();
  const toGuestVisitEdit = () =>
    navigate(`/investors/guest/visits/${guestVisit.id}/edit`);

  const currentLocation = location;
  const currentType = visitType ?? guestVisit.visit_type;

  const fieldMapper: DisplayItem[] = [
    {
      title: 'Estado',
      value: <InvestorVisitsBadge status={guestVisit.visit_status} />,
    },
    {
      title: 'Origen',
      value: `${guestVisit.visit_source} - ${guestVisit.visit_owner}`,
    },
    {
      title: 'Tipo',
      value: onChangeVisitType ? (
        <div style={{ minWidth: 180 }} onClick={(e) => e.stopPropagation()}>
          <Select
            options={visitTypeOptions}
            value={visitTypeOptions.find(
              (opt) => opt.value === (visitType ?? guestVisit.visit_type),
            )}
            onChange={(selected) => {
              if (selected?.value) onChangeVisitType(selected.value);
            }}
          />
        </div>
      ) : guestVisit.visit_type === 'presential' ? (
        'Presencial'
      ) : (
        'Virtual'
      ),
    },
    ...(currentType === VISIT_TYPE_PRESENTIAL
      ? [
          {
            title: 'Lugar',
            value: onChangeLocation ? (
              <div style={{ minWidth: 180 }} onClick={(e) => e.stopPropagation()}>
                <Select
                  options={visitLocationOptions}
                  value={visitLocationOptions.find(
                    (opt) => opt.value === currentLocation,
                  )}
                  placeholder="Selecciona el lugar"
                  onChange={(selected) => {
                    if (selected?.value) onChangeLocation(selected.value);
                  }}
                />
              </div>
            ) : (
              visitLocationOptions.find(
                (opt) => opt.value === currentLocation,
              )?.label || 'No definido'
            ),
          },
          ...(currentLocation === 'project' && projectAddress
            ? [{ title: 'Dirección', value: projectAddress }]
            : []),
          ...(currentLocation === 'office' && officeAddress
            ? [
                {
                  title: 'Dirección',
                  value: (
                    <>
                      {officeAddress.address}
                      {officeAddress.reference &&
                        ` (${officeAddress.reference})`}
                      {officeAddress.maps_url && (
                        <>
                          {' - '}
                          <a
                            href={officeAddress.maps_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Ver en mapa
                          </a>
                        </>
                      )}
                    </>
                  ),
                },
              ]
            : []),
        ]
      : []),
    {
      title: 'Fecha y hora',
      value: `${guestVisit.visit_date} ${guestVisit.visit_time}`,
      href:
        guestVisit.visit_status === VisitPreSaleState.PENDING_APPROVAL ||
        (!guestVisit.visit_proper_selected_id &&
          guestVisit.visit_status === VisitPreSaleState.SCHEDULED)
          ? `/investors/guest/visits/${guestVisit.id}/edit`
          : undefined,
    },
  ];

  return <AdminListGroup title={'Asesoría'} items={fieldMapper} />;
};

export default InvestorVisitDetailCard;
